<template>
    <div class="js_rank">
        <Sticky>
            <div class="header">
                <div class="tabs">
                    <div :class="[active==item.id?'active':'','tab']" @click="active = item.id" v-for="(item,index) in tablist">{{ item.name }}</div>
                </div>
            </div>
        </Sticky>
        <div class="main">
            <div class="myinfo">
                <div>
                    <img class="myavatar" :src="myinfo.avatarurl" />
                    <div class="myrank">
                        <div>{{ myinfo.nickname }}</div>
                        <div >
                            <template v-if="+myinfo.rank > 0">第 <span>{{ myinfo.rank }}</span> 名</template>
                            <template v-else>暂无排名</template>
                        </div>
                    </div>
       
                </div>
                <div>
                    <span>{{myinfo.totalpoint||'-'}}</span>  {{ isPointsRank ? '分' : '步' }}
                </div>
            </div>
            <List
            style="color:#FFF;"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="init"
            >
                <div class="rank-list">
                    <CellGroup style="border-radius:.16rem" v-if="rankList.length" :border="false">
                    <Cell v-for="item in rankList" :key="item.id" center  class="rank">
                        <div slot="title">{{item.userInfo.name||item.userInfo.nickname}}</div>
                        <div slot="icon" class="rank_icon">
                            <template v-if="item.rank <= 3">
                                <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                                <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                                <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
                            </template>

                            <span v-else>{{ item.rank }}</span>
                            <VanImage :src="item.userInfo.avatarurl" />
                        </div>
                        <!-- <div
                        slot="label"
                        v-if="item.create_time"
                        >{{ (systime - item.create_time) | diffentTime(item.create_time) }}</div> -->


                        <span> {{ item.totalsteps*1 }}</span>

                    </Cell>
                    </CellGroup>
                    <Empty
                    style="background: #fff;min-height: 6rem;border-radius:.16rem"
                    v-else
                    description="暂无数据"
                    />
                </div>
            </List>
        </div>
    </div>
</template>

<script>
import "./index.less"
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup, Sticky } from "vant";
export default {
    components: {
        Empty,
        Panel,
        Cell,
        CellGroup,
        List,
        VanImage: Image,
        Row,
        Col,
        Popup,Sticky
    },
    data() {
        return {
            page: 1,
            loading: false,
            finished: false,
            activity_id: this.$route.params.activity_id,
            tablist: [
                {
                    id: 1,
                    name: '新就业形态组'
                },{
                    id: 2,
                    name: '大众组'
                }
            ],
            active: 1,
            myinfo: {},
            rankList: [],
            hasLoadedTabs: false
        }
    },
    created() {
        this.sportsMainPromise = this.$api.sports.sportsMain(this.activity_id)
            .then((res) => {
                if (res && res.data) {
                    return res.data;
                }
                return null;
            })
            .catch((e) => {
                console.error(e);
                return null;
            });
    },
    computed: {
        isPointsRank() {
            return +this.activity_id === 10052;
        }
    },
    watch: {
        active(newvalue, oldvalue) {
            this.page = 1
            this.loading = false
            this.finished = false
            this.init()             
        },
    },
    methods: {
        async init() {
            let sportsData = null;
            try {
                sportsData = await this.sportsMainPromise;
            } catch (e) {
                console.error(e);
            }

            if (!this.hasLoadedTabs) {
                this.hasLoadedTabs = true;
                if (sportsData && sportsData.is_registered && sportsData.registered_info) {
                    const registerType = sportsData.registered_info.register_type;
                    if (registerType) {
                        let parsedTabs = [];
                        if (sportsData.registerform) {
                            try {
                                const formData = JSON.parse(sportsData.registerform);
                                if (Array.isArray(formData)) {
                                    for (const form of formData) {
                                        if (form.attrs && Array.isArray(form.attrs)) {
                                            for (const attr of form.attrs) {
                                                if (attr.key_name === 'register_type') {
                                                    let options = attr.options;
                                                    if (typeof options === 'string') {
                                                        options = JSON.parse(options);
                                                    }
                                                    if (Array.isArray(options)) {
                                                        parsedTabs = options.map(opt => ({
                                                            id: opt.key,
                                                            name: opt.value
                                                        }));
                                                    }
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            } catch (e) {
                                console.error("Error parsing registerform in frontend:", e);
                            }
                        }

                        if (parsedTabs.length > 0) {
                            this.tablist = parsedTabs;
                        }

                        const matchedTab = this.tablist.find(tab => tab.name === registerType || String(tab.id) === String(registerType));
                        if (matchedTab) {
                            if (String(matchedTab.id) !== String(this.active)) {
                                this.active = matchedTab.id;
                                return;
                            }
                        } else {
                            if (this.tablist.length > 0 && String(this.tablist[0].id) !== String(this.active)) {
                                this.active = this.tablist[0].id;
                                return;
                            }
                        }
                    } else {
                        if (this.tablist.length > 0 && String(this.tablist[0].id) !== String(this.active)) {
                            this.active = this.tablist[0].id;
                            return;
                        }
                    }
                } else {
                    if (this.tablist.length > 0 && String(this.tablist[0].id) !== String(this.active)) {
                        this.active = this.tablist[0].id;
                        return;
                    }
                }
            }

            let apiCall = null;
            if (+this.activity_id === 10052) {
                apiCall = this.$api.sports.pointsRank(this.activity_id, {
                    type: this.active,
                    page: this.page
                });
            } else {
                apiCall = this.$api.activity.stepsRank({
                    type: this.active,
                    activity_id: this.activity_id,
                    page: this.page
                });
            }

            apiCall.then((res) => {
                if (+res.status !== 200) {
                    this.finished = true;
                    return;
                }
                this.systime = res.sys_time;
                this.loading = false;
                let {
                    list,
                    page,
                    pages,
                    my,
                    tablist
                } = res.data;
                this.myinfo = my;
                this.rankList = list;

                if (tablist && tablist.length > 0) {
                    this.tablist = tablist;
                }

                let t = null

                this.rankList.forEach((item, index) => {
                    if(t == null){
                        t =  item;
                        t.rank = index+1;
                    }else{
                        var n = item;
                        if(n.totalsteps*1 == t.totalsteps*1){
                            n.rank = t.rank;
                        }else{
                            n.rank = index+1;
                        }
                        t = n;
                    }
                })
                this.finished = true;
            });
        }
    },
}
</script>